import { EmptyState, Spinner } from '@shared/ui';
import { useConversationsQuery } from '@entities/chat';
import { ConversationRow } from './conversation-row';

export function ConversationsList() {
  const { data, isLoading, isError, error } = useConversationsQuery();

  if (isLoading) {
    return (
      <div className="flex justify-center p-6">
        <Spinner />
      </div>
    );
  }
  if (isError) return <p className="p-4 text-sm text-destructive">{error?.message ?? 'Error'}</p>;
  if (!data || data.items.length === 0) {
    return (
      <EmptyState
        className="m-3"
        title="No conversations"
        description="Open a chat from a buy request to start a conversation with a buyer."
      />
    );
  }
  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {data.items.map((c) => (
        <li key={c.id}>
          <ConversationRow conversation={c} />
        </li>
      ))}
    </ul>
  );
}
